import { NavLink } from 'react-router-dom'
import { Icon } from '@carrent/ui'
import { DRIVER_TABS } from './navItems'

export function TabBar() {
  return (
    <nav className="tab-bar" aria-label="Основная навигация">
      {DRIVER_TABS.map((t) => (
        <NavLink
          key={t.to}
          to={t.to}
          end={t.end}
          className={({ isActive }) => `tab-bar__item ${isActive ? 'is-active' : ''}`}
        >
          <Icon name={t.icon} size={22} />
          <span className="tab-bar__label">{t.label}</span>
        </NavLink>
      ))}
    </nav>
  )
}
